type CrossIconProps = {
  active: boolean;
  size?: number;
  fill?: string;
  stroke?: string;
};

const CrossIcon = ({ active, size = 16, fill, stroke = 'white' }: CrossIconProps) => {
  if (active) {
    return (
      <svg width={size} height={size} viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        {fill ? (
          <circle cx="6.47847" cy="6.47847" r="6.47847" fill={fill} stroke="none" />
        ) : (
          <>
            <circle cx="6.47847" cy="6.47847" r="6.47847" fill="url(#paint0_linear_cross)" stroke="none" />
            <defs>
              <linearGradient id="paint0_linear_cross" x1="-1.34079e-07" y1="1.79958" x2="12.2371" y2="10.7975" gradientUnits="userSpaceOnUse">
                <stop stopColor="#5FD5DE" />
                <stop offset={1} stopColor="#C0DE60" />
              </linearGradient>
            </defs>
          </>
        )}
        <path d="M4.33203 4.33203L8.66536 8.66536M8.66536 4.33203L4.33203 8.66536" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }

  return (
    <svg width={size} height={size} viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="6.5" cy="6.5" r={6} stroke="#5D5D5D" />
      <path d="M4.33203 4.33203L8.66536 8.66536M8.66536 4.33203L4.33203 8.66536" stroke="#5D5D5D" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default CrossIcon;
